<template>
  <div class="user-profile">
    <b-row>
      <b-col>
        <profile-info
          :editable="editable"
          :profile="profile"
          :user-kudos="userKudos"
          :user-thanks="userThanks"
          @edit="$emit('edit', { profile })"
        />
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col md="12" lg="6" xl="4" class="mb-4">
        <facts
          :facts="profile.facts"
          :editable="editable"
          @edit="$emit('edit', { profile, from: 'facts' })"
        />
      </b-col>
      <b-col md="12" lg="6" xl="4" class="mb-4">
        <motivations
          :motivations="profile.motivations"
          :editable="editable"
          @edit="$emit('edit', { profile, from: 'motivations' })"
        />
      </b-col>
      <b-col md="12" lg="6" xl="4" class="mb-4">
        <values
          :values="profile.values"
          :editable="editable"
          @edit="$emit('edit', { profile, from: 'values' })"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <skills
          :skills="profile.skills"
          :editable="editable"
          @edit="$emit('edit', { profile, form: 'skills' })"
        />
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col>
        <inspiration
          :image="profile.inspirationImage"
          :editable="editable"
          @edit="$emit('edit', { profile, from: 'inspiration' })"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ProfileInfo from './ProfileInfo.vue'
import Facts from './Facts.vue'
import Skills from './Skills.vue'
import Values from './Values.vue'
import Motivations from './Motivations'
import Inspiration from './Inspiration'

export default {
  name: 'UserProfile',

  props: {
    editable: {
      type: Boolean
    },

    profile: {
      type: Object,
      required: true
    },

    userKudos: {
      type: Object
    },

    userThanks: {
      type: Object
    }
  },

  components: {
    ProfileInfo,
    Facts,
    Skills,
    Values,
    Motivations,
    Inspiration
  }
}
</script>
